import React from "react";

function Adult() {
  return (
    <div className="button">
      <h3>OUI, J'AI PLUS DE 18 ANS</h3>
    </div>
  );
}

export default Adult;
